export const buildDiceSyncFilterGroups = (filterOptions = {}) => [
  {
    id: 'venue',
    label: 'DICE Venue',
    filters: [
      {
        id: 'venue_name',
        label: 'Venue Name',
        type: 'checkbox',
        options: (filterOptions.venue_options || []).map(name => ({
          value: String(name),
          label: name,
        })),
      },
    ],
  },
  {
    id: 'sync_status',
    label: 'Sync Status',
    filters: [
      {
        id: 'status',
        label: 'Status',
        type: 'checkbox',
        options: (filterOptions.status_options || []).map(option => ({
          value: String(option.value),
          label: option.label,
        })),
      },
    ],
  },
];
